import { createEffect, sample } from 'effector';
import $$api from 'models/api';

import AlertsService from 'services/AlertsService';

sample({
    clock: [
        $$api.admin.deleteUserFx.failData,
        $$api.admin.generateDocumentFx.failData,
        $$api.admin.getQInstancesFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});
